import dayjs from 'dayjs';
import { useTranslation } from 'translations/hooks';

import { MobileSingleCardPageWithFilterLayout } from 'business/layout/single-card-page-with-filter-card/mobile';
import { RingPerDayGraphContainer } from 'business/production-and-performance/pages/ring-per-day/components/ring-per-day-graph-container';
import { RingPerDayLegendFilterProvider } from 'business/production-and-performance/pages/ring-per-day/providers/legend-filter';
import { ProdAndPerfFiltersProvider } from 'business/production-and-performance/providers/prod-and-perf-filters-provider';
import { SingleGraphReferenceContextProvider } from 'business/providers/graph-reference';

import { RingPerDayMobileFilter } from './components/ring-per-day-filters';

export const MobileRingPerDay = () => {
  const { t } = useTranslation();

  return (
    <SingleGraphReferenceContextProvider>
      <ProdAndPerfFiltersProvider
        initialFilters={{
          filterType: 'date',
          dateRange: [dayjs().subtract(6, 'day'), dayjs()],
          dayMode: 'shift',
        }}
      >
        <RingPerDayLegendFilterProvider>
          <MobileSingleCardPageWithFilterLayout
            title={t('productionAndPerformance.ringPerDay.title')}
            filters={<RingPerDayMobileFilter />}
          >
            <RingPerDayGraphContainer />
          </MobileSingleCardPageWithFilterLayout>
        </RingPerDayLegendFilterProvider>
      </ProdAndPerfFiltersProvider>
    </SingleGraphReferenceContextProvider>
  );
};
